const LIMIT = 10
const TTL_MS =
  (window.theme?.recentlyViewedExpiryDays ?? 90) * 24 * 60 * 60 * 1000
const CART_ATTRIBUTE_KEY = 'recently_viewed_products'
const SESSION_STORAGE_KEY = 'recentlyViewedProducts'

class RecentlyViewedStore {
  #items = RecentlyViewedStore.prune(RecentlyViewedStore.load())

  static load () {
    const stored = window.localStorage.getItem(SESSION_STORAGE_KEY)
    if (!stored) return []

    return JSON.parse(stored).map(item =>
      typeof item === 'string' ? { handle: item, viewedAt: Date.now() } : item,
    )
  }

  static prune (items) {
    const cutoff = Date.now() - TTL_MS
    return items.filter(item => item.viewedAt > cutoff)
  }

  track () {
    if (window.ShopifyAnalytics.meta.page.pageType !== 'product') {
      return this.sync()
    }

    const handle = window.location.pathname.split('/').pop()
    if (!handle) return

    this.set(handle)
  }

  async set (handle) {
    const newItems = RecentlyViewedStore.prune([
      { handle, viewedAt: Date.now() },
      ...this.#items.filter(item => item.handle !== handle),
    ]).slice(0, LIMIT)

    this.#items = newItems
    window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newItems))

    await window.BAO.Cart.updateCartAttributes({
      [CART_ATTRIBUTE_KEY]: newItems.map(item => item.handle).join(','),
    })

    return newItems
  }

  async sync () {
    this.#items = RecentlyViewedStore.prune(this.#items)
    window.localStorage.setItem(
      SESSION_STORAGE_KEY,
      JSON.stringify(this.#items),
    )

    await window.BAO.Cart.updateCartAttributes({
      [CART_ATTRIBUTE_KEY]: this.#items.map(item => item.handle).join(','),
    })
  }

  get items () {
    return this.#items.slice(0, LIMIT).map(item => item.handle)
  }
}

const store = Object.freeze(new RecentlyViewedStore())
store.track()

window.BAO.RecentlyViewed = {
  store,
}
